// src/hooks/useCart.js

import { useContext } from 'react';
import { CartContext } from '../context/CartContext'; // Ensure this path is correct

const useCart = () => {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }

  return context;
};

export default useCart;